import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FileSaverService } from 'ngx-filesaver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { FileHandle } from 'src/app/shared/directives/drag-drop.directive';
import { AuthUser } from 'src/app/shared/models/auth-user.model';
import { Title } from 'src/app/shared/models/title.model';
import { ValidateImage } from 'src/app/shared/models/validate-image.model';
import { LoadingImagesService } from '../loading-images/loading-images.service';
import { ValidateMoleskinModalComponent } from './validate-moleskin-modal/validate-moleskin-modal.component';

@Component({
  selector: 'app-loading-moleskin',
  templateUrl: './loading-moleskin.component.html',
  styleUrls: ['./loading-moleskin.component.scss']
})
export class LoadingMoleskinComponent implements OnInit {

  files: FileHandle[];
  fileList: File[];
  filterForm: FormGroup;
  modalOptions: NgbModalOptions;
  imageList: ValidateImage[];
  title: Title;
  correctFormat: boolean;
  currentUser: AuthUser;
  s3Url: string;
  currenDate: Date;


  private loadingImagesSubscription: Subscription = null;

  constructor(private formBuilder: FormBuilder,
    private loader: NgxSpinnerService,
    private loadingImagesService: LoadingImagesService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private fileSaverService: FileSaverService) {

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

  }

  ngOnInit() {

    this.files = [];
    this.fileList = [];
    this.imageList = [];
    this.currenDate = new Date();

    this.filterForm = this.formBuilder.group({
      term: [''],
      isbn: [{ value: '', disabled: true }],
      name: [{ value: '', disabled: true }],
      interiores: false,
      exteriores: false
    });

    this.getImages();

  }

  getImages() {

    /*const params = {
      Bucket: 'gbibucketdev',
      Key: '230435-BAJA.jpg'
    }; */

    /* AWS.config.update({
      accessKeyId: 'AKIAXBAOG3GWFANPH34S', secretAccessKey: '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'
    });

    var bucket = new AWS.S3({ params: { Bucket: 'gbibucketdev', Key: '230435-BAJA.jpg' } });

    bucket.getObject(function (err, file) {

      console.log(err);

      var hhshd = encode(file.Body);
      var result = "data:image/jpeg;base64," + encode(file.Body);

      this.s3Url = result;

      console.log(result);

      /* timeout(function () {
        this.s3url = "data:image/jpeg;base64," + encode(file.Body);
      }, 1); 
    }); */

  }

  transform() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.s3Url);
  }

  /**
 * OnDestroy
 */
  ngOnDestroy(): void {
    if (this.loadingImagesSubscription !== null) { this.loadingImagesSubscription.unsubscribe(); }
  }

  filesDropped(files: FileHandle[]): void {
    this.files = files;
  }

  /**
*
* @param searchTerm
*/
  onSearchByOracleKey(searchTerm: string) {

    this.loader.show();

    this.loadingImagesSubscription = this.loadingImagesService.getDataByKey(searchTerm)
      .subscribe((resultOnSearch: Title) => {

        this.loader.hide();

        if (resultOnSearch) {
          this.title = resultOnSearch;

          this.filterForm.patchValue({
            isbn: this.title.isbn,
            name: this.title.title
          });
        }
        else {

          this.filterForm.patchValue({
            isbn: "No se encontro información",
            name: "No se encontro información"
          });

          this.toastr.info('No se encontro información relacionada con clave oracle');

        }

      }, (error) => {
        this.loader.hide();
        console.error(error.message);
      });

  }

  validateImagesMoleskin(): void {

    var interiors;
    this.imageList = [];

    if (this.files.length !== 0) {

      for (let i in this.files) {

        var archive = new ValidateImage(i);
        archive.name = this.files[i].file.name.toLowerCase();
        archive.format = archive.name.substr(-3);

        if (archive.name.includes('_')) {
          var numberIndex = archive.name.indexOf('_');
        } else {
          var numberIndex = archive.name.indexOf('-');
        }

        let val2 = this.filterForm.get('interiores').value;
        let val3 = this.filterForm.get('exteriores').value;

        archive.purpose = 'Portada';

        if (archive.name.includes('4a') || archive.name.includes('4ta')) {
          archive.purpose = 'Contraportada';
        }
        if (val2 == "interiores") {
          archive.purpose = 'Interiores'
          interiors = 'interiores';
        }
        if (val3 == "exteriores") {
          archive.purpose = 'Exteriores'
          interiors = 'exteriores';
        }

        this.imageList.push(archive);

      }

      const modalRef = this.modalService.open(ValidateMoleskinModalComponent, this.modalOptions);
      modalRef.componentInstance.paramList = this.imageList;
      modalRef.componentInstance.paramTitle = this.title;

      modalRef.result.then((result) => {

        this.loader.show();

        for (let i in this.files) {
          this.fileList.push(this.files[i].file);
        }

        this.currentUser = JSON.parse(localStorage.getItem('gbi_auth_user'));

        let term = this.filterForm.get('term').value;
        // let interiors = this.filterForm.get('interiores').value;

        this.loadingImagesService.uploadMoleskin(this.fileList, this.currentUser.email, term.toString(), result.isbn, interiors).subscribe((response: any) => {

          this.files = [];
          this.imageList = [];
          this.fileList = [];
          this.filterForm.reset();

          this.loader.hide();
          this.toastr.info(`Las imagenes se guardaron correctamente`);

          this.fileSaverService.save(response, 'docGBI' + '_' + name + '_' + this.currenDate.toLocaleDateString() + '.txt');

        }, (error) => {
          console.error(error);
          console.log(error);
          this.loader.hide();
          this.toastr.error(`Ha ocurrido un error al guardar la imagen, ${error}`, 'Error');
        });


      }, (reason) => { });
    } else {
      this.toastr.error('No se han agregado imágenes', 'Campos Faltantes');
    }

  }
}

function encode(data) {
  var str = data.reduce(function (a, b) { return a + String.fromCharCode(b) }, '');
  return btoa(str).replace(/.{76}(?=.)/g, '$&\n');
}